import { Box } from '@mui/material'
import { useStore } from '@priolo/jon'
import SelectorStateH from 'components/controls/select/SelectorStateH'
import SubtitleCmp from 'components/header/SubtitleCmp'
import { FunctionComponent } from 'react'
import querySo from 'stores/route/query'
import { URL_PAR } from 'stores/route/utils/types'



interface Props {
}
const CropRecipeDetailHeader: FunctionComponent<Props> = ({
}) => {

	// STORE
	useStore(querySo)

	// HOOKs
	
	// HANDLERs
	const handleStateClose = (state:string) => querySo.setSearchUrl([URL_PAR.CROP_RECIPE_VIEW, state])
	
	// RENDER
	const [stateSel] = querySo.getSearchUrl([URL_PAR.CROP_RECIPE_VIEW])
	const getLabel = (value: CROP_RECIPE_VIEW) => ({
		[CROP_RECIPE_VIEW.COMPLETE]: "VIEW ALL",
		[CROP_RECIPE_VIEW.NO_TASKS]: "NO TASKS",
		[CROP_RECIPE_VIEW.NO_PROPS]: "NO VALUES"
	}[value])

	return (
		<Box sx={{ display: "flex", alignItems: "center" }}>
			<SubtitleCmp sx={{ opacity: 0.8, mr: 1 }} />
			<SelectorStateH
				tooltip="DISPLAYS/HIDES TASKS"
				title="SELECT VIEW TYPE"
				states={Object.values(CROP_RECIPE_VIEW)}
				state={stateSel}
				stateDefault={CROP_RECIPE_VIEW.COMPLETE}
				fnGetLabel={getLabel}
				onClose={handleStateClose}
			/>
		</Box>
	)
}

export default CropRecipeDetailHeader

export enum CROP_RECIPE_VIEW {
	COMPLETE = "all",
	NO_TASKS = "no_tasks",
	NO_PROPS = "no_props",
}

